import ClassicMapFrame from "../../component/ImageEditor/frame/classicMapFrame/classicMapFrame";
import LabelMapFrame from "../../component/ImageEditor/frame/labelMapFrame/labelMapFrame";
import YoungMapFrame from "../../component/ImageEditor/frame/youngMapFrame/youngMapFrame";
import InstaMapFrame from "../../component/ImageEditor/frame/instaMapFrame/instaMapFrame";
import CleanMapFrame from "../../component/ImageEditor/frame/cleanMapFrame/cleanMapFrame";
import ElegantMapFrame from "../../component/ImageEditor/frame/elegantMapFrame/elegantMapFrame";
import CircleMapFrame from "../../component/ImageEditor/frame/circleMapFrame/circleMapFrame";
import BoldMapFrame from "../../component/ImageEditor/frame/boldMapFrame.jsx/boldMapFrame";
const CustomFrames = ({ frameDesign, frameText, orientation }) => {
  let frame = <></>;
  switch (frameDesign.frameStyle) {
    case "Classic":
      frame = (
        <ClassicMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Label":
      frame = (
        <LabelMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Young":
      frame = (
        <YoungMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Insta":
      frame = (
        <InstaMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Clean":
      frame = (
        <CleanMapFrame
          orientation={frameDesign.layout}
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Bold":
      frame = (
        <BoldMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Elegant":
      frame = (
        <ElegantMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
        />
      );
      break;
    case "Circle":
      frame = (
        <CircleMapFrame
          frameText={frameText}
          text_color={`rgba(${frameDesign.textColor.r},${frameDesign.textColor.g},${frameDesign.textColor.b},${frameDesign.textColor.a})`}
          frame_color={`${frameDesign.frameColor}`}
          frameDesign={orientation}
        />
      );
      break;

    default:
      frame = <></>;
  }
  return frame;
};

export default CustomFrames;
